/**
 * COMPONENTE SPONSORS BAR
 * =======================
 * Muestra una barra animada con logos de escritorios/sponsors
 * Ahora obtiene los datos del backend
 */

import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';

const SponsorsBar = () => {
  const [logos, setLogos] = useState([]);

  // Cargar logos de escritorios del backend
  useEffect(() => {
    const fetchEscritorios = async () => {
      try {
        const data = await api.getEscritorios();
        // Extraer solo los filenames
        const filenames = data.map(escritorio => escritorio.filename);

        // Duplicar la lista varias veces para asegurar un scroll infinito fluido
        // Si hay pocos logos, duplicar más veces
        let loopedLogos = [...filenames];
        while (loopedLogos.length < 20) {
          loopedLogos = [...loopedLogos, ...filenames];
        }
        // Una duplicación final para el efecto de loop
        setLogos([...loopedLogos, ...loopedLogos]);
      } catch (error) {
        console.error('Error loading escritorios:', error);
        setLogos([]);
      }
    };

    fetchEscritorios();
  }, []);

  return (
    <div className="bg-gradient-to-r from-gray-800 via-green-900 to-gray-800 py-4 overflow-hidden relative">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-green-500 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="relative z-10">
        <div className="flex animate-scroll">
          {logos.map((logo, index) => (
            <div
              key={index}
              className="flex-shrink-0 mx-2"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-2 hover:bg-white/20 transition-all duration-300 border border-white/20 h-16 w-24 flex items-center justify-center">
                <img
                  src={`https://plazarural.com.uy/uploads/escritorios/${logo}`}
                  alt={logo}
                  className="max-h-12 w-auto object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default SponsorsBar;